// import React, { useMemo, useRef } from 'react';
// import { useParams, useNavigate } from 'react-router-dom'; // 🌟 Removed useSearchParams
// import {
//     Box,
//     Card,
//     CardHeader,
//     CardBody,
//     Heading,
//     Tabs,
//     TabList,
//     TabPanels,
//     Tab,
//     TabPanel,
//     VStack,
//     Text,
//     HStack,
//     Tag,
//     IconButton, 
//     Icon,       
// } from '@chakra-ui/react';
// import { ChevronLeft } from 'lucide-react';
// import { AdminLayout } from '@/components/layout/AdminLayout';
// import { DataTable, type DataTableRef, type DataTableOptions } from '@/components/tables';

// const DetailedExpensesPage = () => {
   
//     const { date: selectedDate } = useParams<{ date: string }>();
//     const navigate = useNavigate();
//     const tableRef = useRef<DataTableRef>(null);
    
//     const displayDate = selectedDate ? new Date(selectedDate).toLocaleDateString('en-US', {
//         month: 'long',
//         day: 'numeric',
//         year: 'numeric'
//     }) : 'All Dates';

//     const access = { 
//         can_view: true, 
//         can_edit: false, 
//         can_create: false, 
//         can_delete: false 
//     };

//     // Construct the params object for the API request
//     const tableParams = useMemo(() => ({
//         transaction_date: selectedDate,
//     }), [selectedDate]);

//     // --- Table Configurations ---
    
//     const issuedBudgetOptions = useMemo(() => ({
//         dataSource: '/reports/issued-budget',
//         primaryKey: 'id',
//         dataKey: 'data',
//         showSelection: false,
//         showCheckboxes: false,
//         showActions: false,
//         displayInModal: false,
//         showActionsColumn: false,
//         dataFields: {
//             transaction_date: { name: 'TRANSACTION DATE', withSort: true },
//             shift: { name: 'SHIFT', withSort: true  },
//             amount: { name: 'AMOUNT', type: 'currency', withSort: true },
//             source: { name: 'SOURCE', withSort: true  },
//         },
//     }), []);

//     const truckExpensesOptions = useMemo(() => ({
//         dataSource: '/reports/truck-trip-expense',
//         primaryKey: 'id',
//         dataKey: 'data',
//         showSelection: false,
//         showCheckboxes: false,
//         showActions: false,
//         displayInModal: false,
//          showActionsColumn: false,
//         dataFields: {
//             transaction_date: { name: 'TRANSACTION DATE', withSort: true },
//             shift: { name: 'SHIFT', withSort: true  },
//             helper_name: { name: 'HELPER NAME', withSort: true  },
//             cash_on_hand: { name: 'CASH ON HAND', type: 'currency', withSort: true  },
//             issued_cash_amount: { name: 'ISSUED CASH', type: 'currency', withSort: true  },
//         },
//     }), []);

//     const partsExpensesOptions = useMemo(() => ({
//         dataSource: '/reports/parts-expense',
//         primaryKey: 'id',
//         dataKey: 'data',
//         showSelection: false,
//         showCheckboxes: false,
//         showActions: false,
//         displayInModal: false,
//         showActionsColumn: false,
//         dataFields: {
//             transaction_date: { name: 'TRANSACTION DATE', withSort: true },
//             shift: { name: 'SHIFT', withSort: true  },
//             plate_number: { name: 'PLATE NO.', withSort: true },
//             receipt_no: { name: 'RECEIPT NO.', withSort: true },
//             article: { name: 'ARTICLE', withSort: true },
//             quantity: { name: 'QTY', withSort: true },
//             amount_per_item: { name: 'AMT/ITEM', type: 'currency', withSort: true },
//             total_amount: { name: 'TOTAL AMT', type: 'currency' },
//         },
//     }), []);

//     const cashAdvancesOptions = useMemo(() => ({
//         dataSource: '/reports/cash-advances',
//         primaryKey: 'id',
//         dataKey: 'data',
//         showSelection: false,
//         showCheckboxes: false,
//         showActions: false,
//         displayInModal: false,
//         showActionsColumn: false,
//         dataFields: {
//             transaction_date: { name: 'TRANSACTION DATE', withSort: true },
//             shift: { name: 'SHIFT', withSort: true },
//             driver_name: { name: 'DRIVER NAME', withSort: true },
//             helper_name: { name: 'HELPER NAME', withSort: true },
//             amount: { name: 'AMOUNT', type: 'currency', withSort: true },
//         },
//     }), []);

//     if (!selectedDate) {
//         return (
//             <AdminLayout>
//                 <Box p={10} textAlign="center">
//                     <Heading size="md" mb={2}>No Date Selected</Heading>
//                     <Text color="gray.600">
//                         Please select a record from the <b>Daily Operations Report</b> to view its details.
//                     </Text>
//                 </Box>
//             </AdminLayout>
//         );
//     }

//     return (
//         <AdminLayout>
//             <Box 
//                 p={6} 
//                 bg="gray.50" 
//                 h="calc(100vh - 64px)" 
//                 display="flex" 
//                 flexDirection="column"
//                 overflow="hidden"
//             >
//                 <VStack spacing={6} align="stretch" h="full" flex="1">
//                     {/* --- 🌟 HEADER SECTION WITH BACK BUTTON --- */}
//                     <Box flexShrink={0}>
//                         <HStack justify="space-between" align="center">
//                             <HStack spacing={3} align="center">
//                                 <IconButton 
//                                     aria-label="Back" 
//                                     icon={<Icon as={ChevronLeft} boxSize={6} />} 
//                                     variant="ghost" 
//                                     size="sm" 
//                                     onClick={() => navigate(-1)} // 🌟 Returns to previous page
//                                 />
//                                 <Box>
//                                     <Heading size="md" mb={0}>Detailed Expenses</Heading>
//                                     <Text fontSize="sm" color="gray.600">
//                                         Breakdown of records for <Text as="span" fontWeight="bold" color="blue.600">{displayDate}</Text>
//                                     </Text>
//                                 </Box>
//                             </HStack>

//                             {selectedDate && (
//                                 <Tag colorScheme="blue" variant="subtle">Filtered by Date</Tag>
//                             )}
//                         </HStack>
//                     </Box>

//                     {/* 2. Card: Fills remaining vertical space */}
//                     <Card 
//                         variant="outline" 
//                         shadow="sm" 
//                         borderRadius="xl" 
//                         bg="white" 
//                         display="flex" 
//                         flexDirection="column" 
//                         flex="1" 
//                         minH={0} 
//                         overflow="hidden"
//                     >
//                         <Tabs 
//                             variant="line" 
//                             colorScheme="blue" 
//                             isLazy 
//                             display="flex" 
//                             flexDirection="column" 
//                             h="full"
//                         >
//                             <CardHeader p={0} borderBottomWidth="1px" flexShrink={0}>
//                                 <TabList px={6}>
//                                     <Tab py={4}><Text fontWeight="bold" fontSize="xs">ISSUED BUDGET</Text></Tab>
//                                     <Tab py={4}><Text fontWeight="bold" fontSize="xs">TRUCK EXPENSES</Text></Tab>
//                                     <Tab py={4}><Text fontWeight="bold" fontSize="xs">PARTS EXPENSES</Text></Tab>
//                                     <Tab py={4}><Text fontWeight="bold" fontSize="xs">CASH ADVANCES</Text></Tab>
//                                 </TabList>
//                             </CardHeader>

//                             <CardBody p={0} flex="1" overflow="hidden" display="flex" flexDirection="column">
//                                 <TabPanels flex="1" h="full">
//                                     <TabPanel p={0} h="full">
//                                         <Box h="full" overflowY="auto"> 
//                                             <DataTable 
//                                                 ref={tableRef}
//                                                 options={issuedBudgetOptions} 
//                                                 params={tableParams} 
//                                                 access={access} 
//                                             />
//                                         </Box>
//                                     </TabPanel>
//                                     <TabPanel p={0} h="full">
//                                          <Box h="full" overflowY="auto">
//                                              <DataTable options={truckExpensesOptions} params={tableParams} access={access} />
//                                          </Box>
//                                      </TabPanel>
//                                      <TabPanel p={0} h="full">
//                                          <Box h="full" overflowY="auto">
//                                              <DataTable options={partsExpensesOptions} params={tableParams} access={access} />
//                                          </Box>
//                                      </TabPanel>
//                                      <TabPanel p={0} h="full">
//                                          <Box h="full" overflowY="auto">
//                                              <DataTable options={cashAdvancesOptions} params={tableParams} access={access} />
//                                          </Box>
//                                      </TabPanel>
//                                 </TabPanels>
//                             </CardBody>
//                         </Tabs>
//                     </Card>
//                 </VStack>
//             </Box>
//         </AdminLayout>
//     );
// };

// export default DetailedExpensesPage;

import React, { useMemo, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Box, Card, CardHeader, CardBody, Heading, Tabs, TabList,
    TabPanels, Tab, TabPanel, VStack, Text, HStack, Tag,
    IconButton, Icon, useColorModeValue 
} from '@chakra-ui/react';
import { ChevronLeft } from 'lucide-react';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { DataTable, type DataTableRef } from '@/components/tables';

const DetailedExpensesPage = () => {
    const { date: selectedDate } = useParams<{ date: string }>();
    const navigate = useNavigate();
    const tableRef = useRef<DataTableRef>(null);

    // Dynamic Colors for Dark Mode Support
    const pageBg = useColorModeValue('gray.50', 'gray.900');
    const cardBg = useColorModeValue('white', 'gray.800');
    const secondaryTextColor = useColorModeValue('gray.600', 'gray.400');
    const accentColor = useColorModeValue('blue.600', 'blue.300');
    const borderColor = useColorModeValue('gray.200', 'gray.700');
    
    const displayDate = selectedDate ? new Date(selectedDate).toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    }) : 'All Dates';

    const access = { 
        can_view: true, 
        can_edit: false, 
        can_create: false, 
        can_delete: false 
    };

    const tableParams = useMemo(() => ({
        transaction_date: selectedDate,
    }), [selectedDate]);

    // --- Table Configurations (Unchanged logic, styles handled by DataTable component) ---
    const issuedBudgetOptions = useMemo(() => ({
        dataSource: '/reports/issued-budget',
        primaryKey: 'id',
        dataKey: 'data',
        showSelection: false,
        showCheckboxes: false,
        showActions: false,
        displayInModal: false,
        showActionsColumn: false,
        dataFields: {
            transaction_date: { name: 'TRANSACTION DATE', withSort: true },
            shift: { name: 'SHIFT', withSort: true  },
            amount: { name: 'AMOUNT', type: 'currency', withSort: true },
            source: { name: 'SOURCE', withSort: true  },
        },
    }), []);

    const truckExpensesOptions = useMemo(() => ({
        dataSource: '/reports/truck-trip-expense',
        primaryKey: 'id',
        dataKey: 'data',
        showSelection: false,
        showCheckboxes: false,
        showActions: false,
        displayInModal: false,
        showActionsColumn: false,
        dataFields: {
            transaction_date: { name: 'TRANSACTION DATE', withSort: true },
            shift: { name: 'SHIFT', withSort: true  },
            helper_name: { name: 'HELPER NAME', withSort: true  },
            cash_on_hand: { name: 'CASH ON HAND', type: 'currency', withSort: true  },
            issued_cash_amount: { name: 'ISSUED CASH', type: 'currency', withSort: true  },
        },
    }), []);

    const partsExpensesOptions = useMemo(() => ({
        dataSource: '/reports/parts-expense',
        primaryKey: 'id',
        dataKey: 'data',
        showSelection: false,
        showCheckboxes: false,
        showActions: false,
        displayInModal: false,
        showActionsColumn: false,
        dataFields: {
            transaction_date: { name: 'TRANSACTION DATE', withSort: true },
            shift: { name: 'SHIFT', withSort: true  },
            plate_number: { name: 'PLATE NO.', withSort: true },
            receipt_no: { name: 'RECEIPT NO.', withSort: true },
            article: { name: 'ARTICLE', withSort: true },
            quantity: { name: 'QTY', withSort: true },
            amount_per_item: { name: 'AMT/ITEM', type: 'currency', withSort: true },
            total_amount: { name: 'TOTAL AMT', type: 'currency' },
        },
    }), []);

    const cashAdvancesOptions = useMemo(() => ({
        dataSource: '/reports/cash-advances',
        primaryKey: 'id',
        dataKey: 'data',
        showSelection: false,
        showCheckboxes: false,
        showActions: false,
        displayInModal: false,
        showActionsColumn: false,
        dataFields: {
            transaction_date: { name: 'TRANSACTION DATE', withSort: true },
            shift: { name: 'SHIFT', withSort: true },
            driver_name: { name: 'DRIVER NAME', withSort: true },
            helper_name: { name: 'HELPER NAME', withSort: true },
            amount: { name: 'AMOUNT', type: 'currency', withSort: true },
        },
    }), []);

    if (!selectedDate) {
        return (
            <AdminLayout>
                <Box p={10} textAlign="center">
                    <Heading size="md" mb={2}>No Date Selected</Heading>
                    <Text color={secondaryTextColor}>
                        Please select a record from the Daily Operations Report to view its details.
                    </Text>
                </Box>
            </AdminLayout>
        );
    }

    return (
        <AdminLayout>
            <Box 
                p={6} 
                bg={pageBg} // FIXED: Dynamic background
                h="calc(100vh - 64px)" 
                display="flex" 
                flexDirection="column"
                overflow="hidden"
            >
                <VStack spacing={6} align="stretch" h="full" flex="1">
                    <Box flexShrink={0}>
                        <HStack justify="space-between" align="center">
                            <HStack spacing={3} align="center">
                                <IconButton 
                                    aria-label="Back" 
                                    icon={<Icon as={ChevronLeft} boxSize={6} />} 
                                    variant="ghost" 
                                    size="sm" 
                                    onClick={() => navigate(-1)} 
                                />
                                <Box>
                                    <Heading size="md" mb={0}>Detailed Expenses</Heading>
                                    <Text fontSize="sm" color={secondaryTextColor}> {/* FIXED: Dynamic text color */}
                                        Breakdown of records for <Text as="span" fontWeight="bold" color={accentColor}>{displayDate}</Text>
                                    </Text>
                                </Box>
                            </HStack>

                            {selectedDate && (
                                <Tag colorScheme="blue" variant="subtle">Filtered by Date</Tag>
                            )}
                        </HStack>
                    </Box>

                    <Card 
                        variant="outline" 
                        shadow="sm" 
                        borderRadius="xl" 
                        bg={cardBg} // FIXED: Dynamic background
                        borderColor={borderColor}
                        display="flex" 
                        flexDirection="column" 
                        flex="1" 
                        minH={0} 
                        overflow="hidden"
                    >
                        <Tabs 
                            variant="line" 
                            colorScheme="blue" 
                            isLazy 
                            display="flex" 
                            flexDirection="column" 
                            h="full"
                        >
                            <CardHeader p={0} borderBottomWidth="1px" borderColor={borderColor} flexShrink={0}>
                                <TabList px={6}>
                                    <Tab py={4}><Text fontWeight="bold" fontSize="xs">ISSUED BUDGET</Text></Tab>
                                    <Tab py={4}><Text fontWeight="bold" fontSize="xs">TRUCK EXPENSES</Text></Tab>
                                    <Tab py={4}><Text fontWeight="bold" fontSize="xs">PARTS EXPENSES</Text></Tab>
                                    <Tab py={4}><Text fontWeight="bold" fontSize="xs">CASH ADVANCES</Text></Tab>
                                </TabList>
                            </CardHeader>

                            <CardBody p={0} flex="1" overflow="hidden" display="flex" flexDirection="column">
                                <TabPanels flex="1" h="full">
                                    <TabPanel p={0} h="full">
                                        <Box h="full" overflowY="auto"> 
                                            <DataTable 
                                                ref={tableRef}
                                                options={issuedBudgetOptions} 
                                                params={tableParams} 
                                                access={access} 
                                            />
                                        </Box>
                                    </TabPanel>
                                    <TabPanel p={0} h="full">
                                         <Box h="full" overflowY="auto">
                                             <DataTable options={truckExpensesOptions} params={tableParams} access={access} />
                                         </Box>
                                     </TabPanel>
                                     <TabPanel p={0} h="full">
                                         <Box h="full" overflowY="auto">
                                             <DataTable options={partsExpensesOptions} params={tableParams} access={access} />
                                         </Box>
                                     </TabPanel>
                                     <TabPanel p={0} h="full">
                                         <Box h="full" overflowY="auto">
                                             <DataTable options={cashAdvancesOptions} params={tableParams} access={access} />
                                         </Box>
                                     </TabPanel>
                                </TabPanels>
                            </CardBody>
                        </Tabs>
                    </Card>
                </VStack>
            </Box>
        </AdminLayout>
    );
};

export default DetailedExpensesPage;